import { Entypo } from '@native-base/icons';
import { Center, HStack, IconButton, Image, Spacer, Text } from 'native-base';
import PropTypes from 'prop-types';
import React from 'react';

function Face({ face, onAdd, onSub, quantity }) {
  return (
    <HStack alignItems="center" py="2">
      <Center width="120">
        <Image
          source={face.image}
          alt="NA"
          width={face.value < 5 ? '70' : '120'}
          height="70"
          borderRadius="10"
        />
      </Center>
      <Spacer />
      <Text
        bg={quantity ? 'info.200' : 'coolGray.200'}
        color={quantity ? 'info.800' : 'coolGray.800'}
        height="6"
        width="6"
        fontSize="16"
        textAlign="center"
        borderRadius="10"
      >
        {quantity}
      </Text>
      <Text> x </Text>
      <Text fontSize="xl" bold>
        {face.display}
      </Text>
      <Spacer />
      <IconButton
        onPress={onSub}
        isDisabled={!quantity}
        variant="solid"
        bg="#ff595e"
        borderRadius="30"
        size="sm"
        mr="2"
        _icon={{
          as: Entypo,
          name: 'minus',
        }}
      />
      <IconButton
        onPress={onAdd}
        variant="solid"
        bg="#8ac926"
        borderRadius="30"
        size="sm"
        _icon={{
          as: Entypo,
          name: 'plus',
        }}
      />
    </HStack>
  );
}

Face.propTypes = {
  face: PropTypes.object.isRequired,
  onAdd: PropTypes.func.isRequired,
  onSub: PropTypes.func.isRequired,
  quantity: PropTypes.number.isRequired,
};

export default Face;
